<script setup>
const props = defineProps({
  minValue: {
    type: Number,
  },
  maxValue: {
    type: Number,
  },
  priceValue: {
    type: Array,
  },
});

const emit = defineEmits(["on-select-price"]);
const price = computed({
  get() {
    return props.priceValue;
  },
  set(value) {
    emit("on-select-price", value);
  },
});
const isListOpen = ref(true);
</script>

<template>
  <div>
    <div
      class="flex justify-between items-center"
      :class="isListOpen ? 'pb-3' : 'pb-0'"
      @click=""
    >
      <p class="font-base font-lato">Цена</p>
      <p-icon-down-arrow
        class="cursor-pointer"
        :isOpen="isListOpen"
        @click="isListOpen = !isListOpen"
      ></p-icon-down-arrow>
    </div>
    <div
      :class="isListOpen ? 'ui-collapse__content_in' : 'ui-collapse__content'"
    >
      <p-product-filter-range-item
        class="mb-3"
        :min="minValue"
        :max="maxValue"
        v-model="price"
      ></p-product-filter-range-item>
    </div>
  </div>
</template>

<style scoped>
.ui-checkbox__input {
  height: 0;
  margin: 0 !important;
  opacity: 0;
  position: absolute;
  top: 50%;
}

.ui-collapse__content_in {
  -o-animation-duration: 0.5s;
  -moz-animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -o-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -o-animation-name: ui-collapse-in;
  -moz-animation-name: ui-collapse-in;
  -webkit-animation-name: ui-collapse-in;
  animation-name: ui-collapse-in;
  opacity: 1;
  overflow: visible !important;
  transition: opacity 0.5s ease-in;
}

.ui-collapse__content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>
